import React from "react";

const HeadernDescription = ({
  section,
  align = "center",
  paddingY = "py-0",
}) => {
  if (!section) return null;

  const { heading, para } = section;

  // 🎯 alignment classes
  const alignClass =
    align === "left"
      ? "text-left items-start"
      : align === "right"
      ? "text-right items-end"
      : "text-center items-center";

  return (
    <div className={`flex flex-col ${alignClass} ${paddingY}`}>
      
      <h2
        className="mb-3"
        style={{
          color: "var(--primary-color)",
          fontSize: "clamp(1.5rem, 2.4vw, 2.6rem)",
        }}
      >
        {heading}
      </h2>
      <p
        className="mb-[4vh] md:mb-[6vh] "
        style={{ color: "var(--primary-color)" }}
      >
        {para}
      </p>
      {/* <p
        className="mb-[4vh] md:mb-[6vh] lg:max-w-[45vw]"
        style={{ color: "var(--primary-color)" }}
      >
        {para}
      </p> */}

    </div>
  );
};

export default HeadernDescription;